import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'

export const Section = styled.div`
  background: radial-gradient(
      65.97% 67.41% at 102.68% 95.82%,
      rgba(130, 215, 221, 0.62) 16.69%,
      rgba(201, 232, 243, 0.62) 85.74%
    ),
    linear-gradient(248deg, #d5b6ec 44.94%, #c1ebee 90.19%);
  background-blend-mode: darken, normal;
  margin: 8px 0px 24px;
  padding: 56px 0px;
  @media (max-width: ${breakpoints.s}px) {
    padding: 40px 0px;
  }
`

export const Container = styled.div`
  width: 90%;
  margin: auto;
  text-align: center;
`
export const Title = styled.h2`
  font-family: 'MatterBold';
  font-size: 30px;
  margin: 0px;
  color: black;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 22px;
  }
`
export const Text = styled.p`
  font-family: 'MatterRegular';
  font-size: 20px;
  color: black;
  line-height: 1.2;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
  }
`
export const ImageContainer = styled.div`
  width: 280px;
  margin: auto;
  @media (max-width: ${breakpoints.s}px) {
    width: 240px;
  }
`
